import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type PaginatedResults } from "shared/api/types/pagination";
import { type SocietyProfileWorkflowParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/workflow/[workflowId]";
import { type SocietyWorkflowInstanceBodyInput } from "shared/api/types/society/[societyId]/workflow/[workflowId]/instance";
import { type WorkflowInstanceView } from "shared/mappers/database/workflow/workflow-instance";
import { type WorkflowInstanceStopped } from "shared/workflow/workflow-instance";
export const postSocietyProfileWorkflowInstanceContract: BaseApiContract<
  SocietyProfileWorkflowParamsInput,
  SocietyWorkflowInstanceBodyInput,
  WorkflowInstanceStopped
> = {
  method: HttpMethod.POST,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/workflow/[workflowId]/instance",
  paramsType: {} as SocietyProfileWorkflowParamsInput,
  bodyType: {} as SocietyWorkflowInstanceBodyInput,
  responseType: {} as WorkflowInstanceStopped,
};
export const getSocietyProfileWorkflowInstanceContract: BaseApiContract<
  SocietyProfileWorkflowParamsInput,
  undefined,
  PaginatedResults<WorkflowInstanceView>
> = {
  method: HttpMethod.GET,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/workflow/[workflowId]/instance",
  paramsType: {} as SocietyProfileWorkflowParamsInput,
  responseType: {} as PaginatedResults<WorkflowInstanceView>,
};
